module.exports = __webpack_public_path__ + "img/properties-placeholder.4e1dc0ef.jpg";